import { ReportPdfModel } from '../models';
import { Observable } from 'rxjs';

export abstract class ReportService {
  abstract getReports(id: string): Observable<ReportPdfModel[]>;
  abstract downloadReport(id: string);
  abstract downloadReportByType(entityId: string, type: number);
}
